import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { makeStyles } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Edit from "../../../../../Images/launchIcon.svg";
import DataService from "../../../../../Service";
import ProgramDrawer from "../../Employee/Program/ProgramDrawer";
import ProgramModal from "../Program/ProgramModal";
import { useSelector } from "react-redux";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import DataClient from "../../../../../Service/general_data_service";
import moment from "moment";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import ActivityLogModal from "../../../Organization/ManageInfo/AssignmentDetail/AssignmentOverview/ActivityLogModal";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Tooltip } from "@material-ui/core";
import ActivityLogToggleModal from "./ActivityLogToggleModal";
const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "5%",
    paddingTop: "0px",
    marginTop: "2rem",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  tableWrapper: {
    padding: "5%",
  },
  title: {
    fontSize: theme.spacing(3),
    fontWeight: 700,
    padding: theme.spacing(2),
  },
  subTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
  },
  paper: {
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    minHeight: "200px",
  },
  detailWrap: {
    padding: "20px",
  },
  root: {
    borderBottom: "none !important",
  },
  actions: {
    borderBottom: "none !important",
    color: "green",
  },
}));

const Program = (props) => {
  const disableEditIcon = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail?.program?.disableEditIcon;
  const disableAddButton = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail?.program?.disableAddButton;
  const dispatch = useDispatch();
  const { organisationId, programFlag, setProgramFlag } = props;
  const globaluserData = useSelector((state) => state.commonReducer);
  const role = globaluserData?.role;
  const classes = useStyles();
  const [materTemplate, setMasterTemplate] = useState([]);
  const [templateLoading, setTemplateLoading] = useState(false);
  const [totalMasterCount, setTotalMasterCount] = useState(100);
  const [masterPage, setMasterPage] = useState(0);
  const [masterPageSize, setMasterPageSize] = useState(5);
  const [currentMasterSelection, setCurrentMasterSelection] = useState({});
  const [currentServiceCategorySelection, setCurrentServiceCategorySelection] =
    useState({});
  const [action, setAction] = useState("");
  const [modal, setModal] = useState(false);
  const [masterModal, setMasterModal] = useState("");
  const [data, setData] = useState([]);

  const [serviceTotalCount, setServiceTotalCount] = useState(100);
  const [servicePage, setServicePage] = useState(0);
  const [servicePageSize, setServicePageSize] = useState(20);

  // Program modal state
  const [dropDownValue, setDropDownValue] = useState(undefined);
  const [includeMatchingFrameworkValue, setIncludeMatchingFrameworkValue] =
    useState(false);
  const [programType, setProgramType] = useState(-1);
  const [inputValue, setInputValue] = useState(undefined);
  const [masterTemplateInputValue, setMasterTemplateInputValue] = useState("");

  const [stepperData, setStepperData] = useState(undefined);
  const [headerType, setHeaderType] = useState(undefined);

  const [headerModal, setHeaderModal] = useState("");
  const [masterHeaderModal, setMasterHeaderModal] = useState("");
  const [headerInputValue, setHeaderInputValue] = useState("");
  const [fetchApiFlag, setFetchApiFlag] = useState(false);
  const [headerName, setHeaderName] = useState("");

  useEffect(() => {
    fetchMasterTemplate();
  }, [masterPageSize, masterPage, organisationId]);

  useEffect(() => {
    fetchPrograms();
  }, [servicePageSize, servicePage, organisationId]);
  console.log(organisationId, "for program");
  const fetchMasterTemplate = () => {
    setTemplateLoading(true);
    const params = {
      page: masterPage + 1 || 1,
      count_per_page: masterPageSize || 20,
    };
    DataService.getDirectData("/master_templates", params)
      .then((response) => {
        if (response?.success && response["master_templates"]?.length) {
          setTotalMasterCount(response?.total_count);
          setMasterTemplate(response?.master_templates);
          setTemplateLoading(false);
        } else {
          setTotalMasterCount(100);
          setMasterTemplate([]);
          setTemplateLoading(false);
        }
      })
      .catch((err) => {
        setTemplateLoading(false);
      });
  };

  const fetchPrograms = () => {
    const params = {
      organisation_id: organisationId,
      page: servicePage + 1 || 1,
      count_per_page: servicePageSize || 20,
    };
    DataService.getDirectData("/programmes", params)
      .then((res) => {
        if (res?.success) {
          setServiceTotalCount(res?.total_count);
          res?.programmes?.map((dd) => {
            return (dd[
              "number_of_assignment"
            ] = `No. of assignments: ${dd?.number_of_assignment}`);
          });
          setData(res?.programmes);
        }
      })
      .catch((error) => {});
  };

  const handleModal = (boolValue) => {
    setModal(boolValue);
  };
  const errorEnum = {
    activity_name: "",
    comments: "",
    date: false,
  };
  const [addNewLog, setAddNewLog] = useState({
    isOpen: false,
    selection: null,
  });
  const [activityData, setActivityData] = useState(errorEnum);
  const [errorLogs, setErrorLogs] = useState({
    activity_name: false,
    date: false,
  });
  const setNewInputState = (inputStateValue, inputId) => {
    setErrorLogs({ ...errorLogs, [inputId]: false });
    setActivityData({ ...activityData, [inputId]: inputStateValue });
  };
  const handleClose = () => {
    setAddNewLog({ isOpen: false, selection: null });
    setActivityData({
      ...activityData,
      activity_name: "",
      comments: "",
      date: null,
    });
    setErrorLogs(errorEnum);
  };
  const saveActivityDetails = (isEdit, index) => {
    let isError = false;
    // setLoading(true);
    if (!activityData?.activity_name) {
      isError = true;
      setErrorLogs((oldValue) => ({ ...oldValue, activity_name: true }));
    }
    if (!activityData?.date) {
      isError = true;
      setErrorLogs((oldValue) => ({ ...oldValue, date: true }));
    }
    if (!isError) {
      const pdata = {
        activity_name: activityData.activity_name,
        date: moment(activityData.date).format("DD-MM-YYYY"),
        comments: activityData.comments,
        programme_id: addNewLog?.selection?.id,
      };

      DataClient.create(pdata, "activity_logs")
        .then((res) => {
          if (res?.success) {
            dispatch(showSnackbar("Success", [res.message]));
            handleClose();
            // setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          // setLoading(false);
        });
    } else {
      // setLoading(false);
    }
  };
  const [miFieldsPopupOpen, setMiFieldsPopupOpen] = useState({
    selection: null,
    open: false,
  });
  return (
    <>
      <div className={classes.wrapper}>
        {/* Service Category Section */}
        <div className={classes.header}>
          <Typography
            style={{
              paddingTop: "15px",
              fontWeight: "bold",
              paddingBottom: "15px",
            }}
            variant="h1"
            color="primary"
          >
            Program
          </Typography>

          <div>
            {!disableAddButton && (
              <Button
                style={{ margin: "1rem", textTransform: "none" }}
                onClick={() => {
                  setInputValue(undefined);
                  setDropDownValue(undefined);
                  handleModal(true);
                }}
                variant="contained"
                color="secondary"
              >
                + Create new program
              </Button>
            )}
            {/* {!disableAddButton && (
              <Button
                style={{ margin: "1rem", textTransform: "none" }}
                onClick={() => {
                  setAddNewLog(true);
                }}
                variant="contained"
                color="secondary"
              >
                Add new activity log field
              </Button>
            )} */}
          </div>
        </div>
        <div id="coach-rate-card-border">
          <MaterialTable
            classes={{
              root: classes.root,
              actions: classes.actions,
            }}
            options={{
              toolbar: false,
              header: false,
              rowStyle: {
                borderBottom: "none",
              },
              pageSizeOptions: [20, 50, 75, 100],

              maxBodyHeight: "600px",
              cellStyle: {
                borderBottom: "none",
              },
              headerStyle: {
                position: "sticky",
                top: "0",
                color: "#3B86FF",
                marginTop: "10px",
                borderBottom: "none",
              },
              actionsColumnIndex: -1,
              search: false,
              actionsCellStyle: {
                borderBottom: "none",
              },
              pageSize: servicePageSize,
              total: serviceTotalCount,
            }}
            style={{ width: "100%" }}
            columns={[
              { title: "Name", field: "name" },
              { title: "Number of assignment", field: "number_of_assignment" },
              {
                title: "",
                id: "add_activity",
                render: (rowData) => {
                  return (
                    <Button
                      style={{
                        textTransform: "none",
                        padding: "0.25rem 0.5rem",
                      }}
                      onClick={() => {
                        setAddNewLog({
                          isOpen: true,
                          selection: rowData,
                        });
                      }}
                      variant="contained"
                      color="secondary"
                    >
                      Add Activity
                    </Button>
                  );
                },
              },
              {
                title: "",
                id: "view_mi",
                render: (rowData) => {
                  return (
                    <Tooltip
                      title={<TooltipWrapper text="View MI Fields" />}
                      children={
                        <VisibilityIcon
                          fontSize="small"
                          onClick={() => {
                            setMiFieldsPopupOpen({
                              selection: rowData,
                              open: true,
                            });
                          }}
                        />
                      }
                    />
                  );
                },
              },
            ].filter((el) => {
              if (role === "employee") {
                if (el.id === "view_mi" || el.id === "add_activity") {
                  return false;
                }
                return true;
              }
              return true;
            })}
            data={data}
            totalCount={serviceTotalCount}
            page={servicePage}
            onChangePage={(page) => {
              setServicePage(page);
            }}
            onChangeRowsPerPage={(pageSize) => {
              setServicePageSize(pageSize);
            }}
            onRowClick={(e, rowData) => {
              setCurrentServiceCategorySelection(rowData);
            }}
            actions={[
              !disableEditIcon && {
                icon: () => <EditIcon fontSize="small" />,
                iconProps: { style: { fontSize: "14px", color: "green" } },
                tooltip: <TooltipWrapper text="Edit" />,
                onClick: (event, rowData) => {
                  window.document.getElementById("root")?.scrollIntoView(true);
                  setCurrentServiceCategorySelection(rowData);
                  setAction("editProgram");
                },
              },
            ]}
          />
        </div>
        {miFieldsPopupOpen.open && (
          <ActivityLogToggleModal
            isOpen={miFieldsPopupOpen.open}
            selection={miFieldsPopupOpen.selection}
            onClose={() => {
              setMiFieldsPopupOpen({ selection: null, open: false });
            }}
          />
        )}
        {addNewLog && (
          <ActivityLogModal
            isOpen={addNewLog.isOpen}
            selection={addNewLog.selection}
            setNewInputState={setNewInputState}
            activityData={activityData}
            errorLogs={errorLogs}
            onClose={() => handleClose()}
            onsubmit={() => saveActivityDetails(false, 0)}
            addToProgram={false}
          />
        )}
        {action === "editMaster" && (
          <ProgramDrawer
            {...props}
            handleClose={() => setAction("")}
            currentSelection={currentMasterSelection}
            inputValue={inputValue}
            setInputValue={setInputValue}
            setModal={setModal}
            action={action}
            setAction={setAction}
            setStepperData={setStepperData}
            stepperData={stepperData}
            setHeaderType={setHeaderType}
            headerType={headerType}
            headerModal={headerModal}
            setHeaderModal={setHeaderModal}
            setFetchApiFlag={setFetchApiFlag}
            fetchApiFlag={fetchApiFlag}
            headerName={headerName}
            setHeaderName={setHeaderName}
            setProgramFlag={setProgramFlag}
            programFlag={programFlag}
            setHeaderInputValue={setHeaderInputValue}
            headerInputValue={headerInputValue}
          />
        )}

        {modal && (
          <ProgramModal
            {...props}
            isOpen={modal}
            onCreateProgramClose={() => {
              handleModal(false);
            }}
            handleClose={() => setAction("")}
            organisationId={organisationId}
            inputValue={inputValue}
            setInputValue={setInputValue}
            dropDownValue={dropDownValue}
            setDropDownValue={setDropDownValue}
            setModal={setModal}
            action={action}
            setAction={setAction}
            setStepperData={setStepperData}
            stepperData={stepperData}
            setHeaderType={setHeaderType}
            headerType={headerType}
            headerModal={headerModal}
            setHeaderModal={setHeaderModal}
            setFetchApiFlag={setFetchApiFlag}
            fetchApiFlag={fetchApiFlag}
            headerName={headerName}
            setHeaderName={setHeaderName}
            setProgramFlag={setProgramFlag}
            programFlag={programFlag}
            setHeaderInputValue={setHeaderInputValue}
            {...{
              includeMatchingFrameworkValue,
              setIncludeMatchingFrameworkValue,
              programType,
              setProgramType,
            }}
          />
        )}

        {action === "editProgram" && (
          <ProgramDrawer
            {...props}
            handleClose={() => setAction("")}
            currentSelection={currentServiceCategorySelection}
            inputValue={inputValue}
            setInputValue={setInputValue}
            setModal={setModal}
            action={action}
            setAction={setAction}
            setStepperData={setStepperData}
            stepperData={stepperData}
            setHeaderType={setHeaderType}
            headerType={headerType}
            headerModal={headerModal}
            setHeaderModal={setHeaderModal}
            setFetchApiFlag={setFetchApiFlag}
            fetchApiFlag={fetchApiFlag}
            headerName={headerName}
            setHeaderName={setHeaderName}
            setProgramFlag={setProgramFlag}
            programFlag={programFlag}
            setHeaderInputValue={setHeaderInputValue}
          />
        )}
      </div>
      {/* </div> */}
    </>
  );
};

export default Program;
